import { useQuery } from "@apollo/client";
import { Card } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import { getTeamDetailsQuery } from "src/queries/group.graphql";

import { useAIDashboardStore } from "../context/AIDashboardContext";

const withTeam = (Component) => {
  const WrappedComponent = (props) => {
    const { channel } = props;
    const store = useAIDashboardStore(channel);
    const teamId = store((state) => state.value?.id);

    const { data, loading, error, refetch } = useQuery(getTeamDetailsQuery, {
      variables: { groupId: teamId },
      skip: !teamId,
    });

    const team = data?.getGroup;

    if (!teamId) {
      return (
        <Card style={{ padding: "16px", textAlign: "center", color: "#666" }}>
          Enter a Team ID to see details
        </Card>
      );
    }

    if (loading) {
      return (
        <Card style={{ padding: "16px", textAlign: "center" }}>
          Loading team details...
        </Card>
      );
    }

    if (error) {
      return (
        <Card
          style={{ padding: "16px", textAlign: "center", color: "#d32f2f" }}
        >
          Error loading team: {error.message}
        </Card>
      );
    }

    if (!team) {
      return (
        <Card style={{ padding: "16px", textAlign: "center", color: "#666" }}>
          Team not found
        </Card>
      );
    }

    return <Component {...props} team={team} refetch={refetch} />;
  };

  WrappedComponent.propTypes = {
    channel: PropTypes.string.isRequired,
  };

  return WrappedComponent;
};

export default withTeam;
